module.exports = __webpack_public_path__ + "static/media/tuberSmallLogo.79a8e71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/header/tuberSmallLogo.png
// module id = 322
// module chunks = 0